"use strict";
exports.__esModule = true;
exports.path = void 0;
var ramda_1 = require("ramda");
exports.path = ramda_1.curry(function (str, data) { return ramda_1.path(ramda_1.split('.', str), data); });
//# sourceMappingURL=path.js.map